import { useMemo } from "react";
import { useT } from "../../i18n";

export const STREAM_BASE_URL = process.env.REACT_APP_DRONE_STREAM_URL || "";

export default function DroneStreamViewer({
  serialNum = "",
  isLive = false,
  title,
}) {
  const t = useT();
  const resolvedUrl = useMemo(() => {
    const base = STREAM_BASE_URL.replace(/\/+$/, "");
    const serial = (serialNum ?? "").trim();
    if (!base || !serial) return "";
    return `${base}/${serial}`;
  }, [serialNum]);

  const resolvedTitle = title ?? t("common.stream.defaultTitle");
  const label = !resolvedUrl
    ? t("common.stream.badge.noStream")
    : isLive
      ? t("common.stream.badge.live")
      : t("common.stream.badge.offline");

  return (
    <section className="drone-stream-viewer" aria-label={resolvedTitle}>
      <div className={`drone-stream-badge ${isLive ? "is-live" : ""}`}>
        <span className="dot" />
        <span>{label}</span>
      </div>
      {resolvedUrl ? (
        <iframe
          title={resolvedTitle}
          src={resolvedUrl}
          allow="autoplay; fullscreen"
        />
      ) : (
        <div className="drone-stream-empty">{t("common.stream.noUrl")}</div>
      )}
    </section>
  );
}
